import { defineEffect } from '../../../core/effect';
import { chainingSpec } from '../fx/chaining';

/** 発動（場のカード）（Issue #589。状況は共通側の `editorPorts/duelSituations/chaining.js` が決め、絵の組み立ては `../fx/chaining.js`） */
export default defineEffect({ situation: 'chaining_field', role: 'motion', ...chainingSpec(true) }, 'chaining_field_motion.js');
